import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { Container, Row, Col } from 'reactstrap';

import { STANDARD_SUB } from '../../../constants/subscriptions';
import Button from '../../shared/Button';
import { toTimeString } from '../../../utils/dates';

import styles from './styles.scss';

const propTypes = {
  name: PropTypes.string,
  description: PropTypes.string,
  standardTemplate: PropTypes.object,
  lowTemplate: PropTypes.object,
  moderateTemplate: PropTypes.object,
  highTemplate: PropTypes.object,
  link: PropTypes.string,
  companyId: PropTypes.string,
  isSubStandard: PropTypes.string,
  tzAbbr: PropTypes.string,
};

class ReportLayoutInfo extends React.Component {
  render() {
    const { name, description, standardTemplate, lowTemplate, moderateTemplate, highTemplate, isSubStandard } =
      this.props;

    return (
      <Container fluid className={`py-4 mb-2 ${styles.reportContainer}`}>
        <Row>
          <Col className={styles.header}>
            <h3>{name}</h3>
          </Col>
        </Row>
        <Row>
          <Col className={styles.description}>{description}</Col>
        </Row>
        <div className="m-4 mb-1">
          <If condition={standardTemplate}>{this.renderTemplate('Standard Template', standardTemplate)}</If>
        </div>
        <div
          className={classNames('m-4 mt-1', {
            [styles.disabled]: isSubStandard,
          })}
        >
          <If condition={highTemplate}>{this.renderTemplate('High Results', highTemplate, isSubStandard)}</If>
          <If condition={moderateTemplate}>
            {this.renderTemplate('Moderate Results', moderateTemplate, isSubStandard)}
          </If>
          <If condition={lowTemplate}>{this.renderTemplate('Low Results', lowTemplate, isSubStandard)}</If>
        </div>
      </Container>
    );
  }

  renderTemplate(name, template, disabled = false) {
    const { link, companyId, tzAbbr } = this.props;
    const { lastUpdated, lastEditedByWhom, type: reportType } = template;

    return (
      <Row
        className={classNames('mb-2', {
          [styles.disabled]: false,
        })}
      >
        <Col className="text-left">
          <strong>{name}</strong>
        </Col>
        <Col>{this.getLastUpdatedString(lastUpdated, lastEditedByWhom, tzAbbr)}</Col>
        <Col className="text-right">
          <Link to={disabled ? '#' : `${link}/${reportType}/${companyId}`}>
            <Button kind="primary" disabled={disabled}>
              <i className="fa fa-edit mr-2" />
              Edit
            </Button>
          </Link>
        </Col>
      </Row>
    );
  }

  getLastUpdatedString(date, user, abbr) {
    const lastUpdatedDate = date ? toTimeString(date, abbr) : '';
    const lastUpdatedBy = user ? `by ${user.firstName} ${user.lastName}` : '';
    return `Last updated ${lastUpdatedDate} ${lastUpdatedBy}`;
  }
}

ReportLayoutInfo.propTypes = propTypes;

const mapStateToProps = ({ profile }) => ({
  isSubStandard: profile.isSubStandard,
  tzAbbr: profile.tzAbbr,
});

export default connect(mapStateToProps)(ReportLayoutInfo);



// WEBPACK FOOTER //
// src/components/reportManagement/ReportLayoutInfo/index.jsx